import { z } from "zod";

// What `GET /optro-access/{kind}/{id}` can be asked about. Session kinds are
// checked against the control or work step they belong to.
export const OptroAccessKindSchema = z.enum([
  "control",
  "work-step",
  "control-session",
  "work-step-session",
  "collab-control-session",
  "collab-work-step-session",
]);
export type OptroAccessKind = z.infer<typeof OptroAccessKindSchema>;

// 200: the entity may be shown. `not_linked` means Optro has no say over it.
export const OptroAccessResponseSchema = z.object({
  status: z.enum(["allowed", "not_linked"]),
});

// The `detail` of a refusal. `code` is the contract; `message` is backend copy
// the page does not show (it renders its own per-state copy).
export const OptroAccessErrorDetailSchema = z.object({
  code: z.enum([
    "optro_sign_in_required",
    "optro_view_denied",
    "optro_access_unavailable",
  ]),
  message: z.string(),
});

export type OptroViewAccessState =
  | "checking"
  | "allowed"
  | "signInRequired"
  | "denied"
  | "unavailable"
  | "notFound";

// Every outcome that keeps the entity off screen.
export type OptroAccessFailure = Exclude<
  OptroViewAccessState,
  "checking" | "allowed"
>;

export interface OptroViewAccess {
  state: OptroViewAccessState;
  retry: () => void;
}

// The flag the Controls, Work Steps and Fieldwork list endpoints carry: true
// when Midship couldn't ask Optro which linked rows the user may view, so the
// backend left every Optro-linked row out. Absent (an older backend) = false.
export const OptroAccessListFlagSchema = z.object({
  optroAccessUnavailable: z.boolean().default(false),
});
